// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {isNotEmpty} from '../../../claim/shared/services/claim-shared-helper';

const LaborStatsButtonGroup = props => {

    const canExecuteReport = isNotEmpty(props.partNumber);

    return (
        <div className='labor-stats-button-group'>
            <button
                className='secondary-button'
                onClick={props.onCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!canExecuteReport}
                onClick={props.onPartSearchExecute}
                type='submit'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    );

};

LaborStatsButtonGroup.displayName = 'LaborStatsButtonGroup';
LaborStatsButtonGroup.propTypes = {
    onCriteriaReset: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired,
    partNumber: PropTypes.string.isRequired
};

export default LaborStatsButtonGroup;



// WEBPACK FOOTER //
// ./src/reports/labor-stats/components/labor-stats-button-group.js